import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n'
import browserDetect from "vue-browser-detect-plugin";

import App from './App.vue'
import it from '../i18n/messages/it';
import en from '../i18n/messages/en';
import de from '../i18n/messages/de';
import es from '../i18n/messages/es';
import fr from '../i18n/messages/fr';

Vue.use(browserDetect);
Vue.use(VueRouter)
Vue.use(VueAxios, axios)

Vue.use(VueI18n)

Vue.config.productionTip = false

const messages = {
    it: it,
    en: en,
    es: es,
    de: de,
    fr: fr,
};

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/:lang',
        },
        {
            path: '/:lang/brands/:brand',
            meta: {brandNavigation: true}
        },
        {
            path: '/:lang/:top',
        },
        {
            path: '/:lang/:top/:category',
        },
        {
            path: '/:lang/:top/:category/:group',
        }
    ],
});

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'it', // set locale
    fallbackLocale : 'it',
    messages, // set locale messages
})

/* eslint-disable no-new */
new Vue({
    router,
    i18n,
    template: '<App/>',
    components: {
        App,
    },
}).$mount('#app');
